import React, { useEffect, useRef } from "react";
import { Lock, Bot, User, Headset } from "lucide-react";
import { Markdown } from "../../../components/MarkdownLite";
import { AttachmentList } from "./AttachmentList";
import { fmtDt } from "./supportUtil";

function Bubble({ m }) {
  if (m.author_kind === "system") return <div className="flex justify-center" data-testid={`msg-${m.id}`}><p className="max-w-[80%] rounded-full bg-slate-100 px-3 py-1 text-center text-[11px] text-slate-500">{m.body} · {fmtDt(m.created_at)}</p></div>;
  const staff = m.author_kind === "staff";
  const Icon = staff ? Headset : m.author_kind === "user" ? User : Bot;
  return (
    <div className={`flex gap-2.5 ${staff ? "flex-row-reverse" : ""}`} data-testid={`msg-${m.id}`}>
      <span className={`mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${m.internal ? "bg-amber-100 text-amber-700" : staff ? "bg-brand text-white" : "bg-slate-200 text-slate-600"}`}><Icon size={14} /></span>
      <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm ${m.internal ? "border border-amber-200 bg-amber-50 text-amber-950" : staff ? "bg-brand-soft text-slate-900" : "border border-line bg-white text-slate-800"}`}>
        <p className="mb-1 flex flex-wrap items-center gap-x-2 text-[11px] text-slate-500"><span className="font-bold text-slate-700">{m.author_name || (staff ? "Staf" : "Pengguna")}</span>{m.author_role && <span>· {m.author_role}</span>}<span>· {fmtDt(m.created_at)}</span>{m.internal && <span className="inline-flex items-center gap-1 rounded-full bg-amber-200 px-1.5 py-0.5 text-[10px] font-bold text-amber-900" data-testid={`msg-internal-${m.id}`}><Lock size={9} /> Internal</span>}</p>
        <Markdown text={m.body} />
        <AttachmentList items={m.attachments} compact testid={`msg-att-${m.id}`} />
      </div>
    </div>
  );
}

export function TicketThread({ messages }) {
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: "nearest" }); }, [messages?.length]);
  return (
    <div className="space-y-4" data-testid="ticket-thread">
      {messages?.length === 0 && <p className="text-center text-xs text-slate-400">Belum ada pesan.</p>}
      {messages?.map((m) => <Bubble key={m.id} m={m} />)}
      <div ref={end} />
    </div>
  );
}
